<div class="p-8">
  <h1 class="inline-flex">
    {{ title }}
  </h1>
  <div class="text-sm mb-4">
    <a
      [routerLink]="'../../corporation/' + corporationId + '/settings'"
      [queryParams]="{ view: 'payor' }"
      >Return to Previous</a
    >
  </div>
  <div class="mt-20">
    <ng-container *ngIf="id !== 'add' && payor; else noTab">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel">
        <a
          mat-tab-link
          *ngFor="let link of tabRouteMapping"
          [routerLink]="link.route"
          (click)="onTabClick(link.route)"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
        >
          {{ link.display }}
        </a>
      </nav>
      <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
      </mat-tab-nav-panel>
    </ng-container>
  
    <ng-template #noTab>
      <router-outlet></router-outlet>
    </ng-template>
  </div>
  
</div>